import './Tab1.css';
import './Tabs.css';

import { menuController } from '@ionic/core';
import { IonButton, IonCard, IonCardContent, IonCol, IonContent, IonIcon, IonItem, IonPage, IonRow, IonText, useIonViewDidEnter } from '@ionic/react';
import { albumsOutline, cardOutline, checkmarkCircleOutline, checkmarkOutline, cloudDownloadOutline, downloadOutline, readerOutline } from 'ionicons/icons';

import Container from '../../layouts/Container';
import TitleText from '../../layouts/TitleText';
import Toolbar from '../../layouts/Toolbar';
import ActiveProjects from './Home/ActiveProjects';
import Banners from './Home/Banners';
import Categories from './Home/Categories';
import FinalizedProjects from './Home/FinalizedProjects';
import LayoutGap from '../../layouts/LayoutGap';
import { isWebView, passToWebView } from '../../library/Funcs';
import EventsPay from './Tour/PayTour';

interface Props {
  showShop: any,
  eventsPay: [],
  banners: [],
  categories: [],
  activeProjects: [],
  finalizedProjects: []
}

const Tab1: React.FC<Props> = (props) => {
  return <IonPage className="tab-content">
    <Toolbar title="نذرطبیعت" hasMenuButton menuButtonClick={async () => await menuController.toggle("mainMenu")}>
      {/* <IonButton shape="round">
          <IonIcon icon={searchOutline}/>
        </IonButton> */}
      {!isWebView() ?
        <IonButton fill="solid" color="danger" shape="round" href="https://www.nazretabiat.ir/application" target="_blank">
          <IonIcon icon={cloudDownloadOutline} />
        </IonButton> : null}
    </Toolbar>

    <LayoutGap />

    <IonContent className="main-content">
      <IonCard className="banner">
        <Banners banners={props.banners} showShop={props.showShop} />
      </IonCard>

      <Container>
        <Categories items={props.categories} />

        <EventsPay eventsPay={props.eventsPay}/>

        <Container>
          <TitleText icon={albumsOutline}>پروژه‌های فعال</TitleText>

          <ActiveProjects items={props.activeProjects} />
        </Container>

        <Container>
          <TitleText icon={readerOutline}>گزارش پروژه ها</TitleText>

          <FinalizedProjects items={props.finalizedProjects} />
        </Container>
      </Container>
    </IonContent>
  </IonPage>
}

export default Tab1;
